'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

var _utils = require('./../utils');

var _FAIcon = require('./../icon/FAIcon');

var _FAIcon2 = _interopRequireDefault(_FAIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function debounce(func, wait, immediate) {
    if (!wait) return func;

    var timeout;

    return function () {
        var context = this,
            args = arguments;

        var later = function later() {
            timeout = null;

            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
}

/**
 * Hledací field, který posílá hledaný text se spožděním, když uživatel nic nepíše nebo jen při stusku enter nebo hledacího tlačítka.
 */

var SearchField = function (_AbstractField) {
    (0, _inherits3.default)(SearchField, _AbstractField);

    function SearchField(props) {
        (0, _classCallCheck3.default)(this, SearchField);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchField.__proto__ || (0, _getPrototypeOf2.default)(SearchField)).call(this, props));

        _this.handleSearchChange = function (e) {
            var _this$props = _this.props,
                searchOnChange = _this$props.searchOnChange,
                onChange = _this$props.onChange;

            var value = e.target.value;
            _this.setState({
                searchText: value
            });
            if (searchOnChange) {
                _this.doSearch(value, onChange);
            }
        };

        _this.handleSearch = function () {
            var onChange = _this.props.onChange;
            var searchText = _this.state.searchText;

            onChange(searchText);
        };

        _this.handleKeyDown = function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                _this.handleSearch();
            }
        };

        _this.doSearch = debounce(function (text, onSearch) {
            onSearch(text);
        }, props.debounceTime);

        _this.state = {
            searchText: props.value
        };
        return _this;
    }

    (0, _createClass3.default)(SearchField, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                this.setState({
                    searchText: nextProps.value
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                debounceTime = _props.debounceTime,
                searchOnChange = _props.searchOnChange,
                disabled = _props.disabled,
                addonsAfter = _props.addonsAfter,
                onChange = _props.onChange,
                value = _props.value,
                customButton = _props.customButton,
                addonsBefore = _props.addonsBefore,
                props = (0, _objectWithoutProperties3.default)(_props, ['debounceTime', 'searchOnChange', 'disabled', 'addonsAfter', 'onChange', 'value', 'customButton', 'addonsBefore']);
            var searchText = this.state.searchText;

            // const wrapperClassNames = classNames(
            //     className,
            //     "search-field-container",
            // );

            var button = customButton ? customButton : _react2.default.createElement(
                _reactstrap.Button,
                { disabled: disabled,
                    onClick: this.handleSearch,
                    type: 'button' },
                _react2.default.createElement(_FAIcon2.default, { icon: 'search' })
            );

            var searchAddons = _react2.default.createElement(
                'div',
                { key: 'searchAddons', className: 'input-group-btn' },
                button
            );

            var field = _react2.default.createElement(_reactstrap.Input, (0, _extends3.default)({
                type: 'text',
                disabled: disabled
            }, props, {
                onKeyDown: this.handleKeyDown,
                value: searchText,
                onChange: this.handleSearchChange
            }));

            return this.renderFieldWithAddons(field, addonsBefore, (0, _utils.mergeAddons)(addonsAfter, searchAddons));
        }
    }]);
    return SearchField;
}(_AbstractField3.default);

SearchField.PropTypes = {
    debounceTime: _react2.default.PropTypes.number,
    searchOnChange: _react2.default.PropTypes.bool, // pokud je true, hledá se hned při psaní se spožděním debounceTime, pokud je false, hledá se při stisku hledat nebo enter
    customButton: _react2.default.PropTypes.node
};
SearchField.defaultProps = {
    debounceTime: 250,
    searchOnChange: false
};
exports.default = SearchField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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